import { Card, CardContent } from '@shared/components';
import { formatVerbatimMoneyCurrency } from '@shared/utils/formatMoneyDisplay';
import type { TotalsEntry } from '../../utils/statementRows';

interface Props {
    totals: TotalsEntry[];
    currency: string;
}

export function ScheduledTotalsCard({ totals, currency }: Props) {
    return (
        <Card>
            <CardContent className="py-5">
                <section aria-label="Scheduled totals" className="@container space-y-3">
                    <h3 className="text-base font-semibold text-mp-foreground">Scheduled</h3>
                    <div className="grid @md:grid-cols-3">
                        <dl className="grid gap-4 text-mp-foreground @md:col-span-2 @md:grid-cols-2">
                            {totals.map((entry) => (
                                <div key={entry.key} className="space-y-1">
                                    <dt className="text-sm text-mp-muted">{entry.label}</dt>
                                    <dd className="text-xl font-semibold">{formatVerbatimMoneyCurrency(entry.value, currency)}</dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                </section>
            </CardContent>
        </Card>
    );
}
